import React, { useState } from 'react';
import UserInput from './inputs/UserInput'
import Table from '../../common/Table';
import { auth } from '../../firebase/Firebase';
import { query, where, collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase/Firebase';

const Users = () => {
  const [currentItem, setCurrentItem] = useState(null);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const orgId = localStorage.getItem('orgId');

  const userHeaders = [
    { label: 'First Name', key: 'firstName' },
    { label: 'Last Name', key: 'lastName' },
    { label: 'Email', key: 'email' },
    { label: 'Role', key: 'role' },
    { label: 'Id', key: 'id' }
  ]

  const handleDelete = async (item) => {
    if (item.role === "Admin") {
      const adminQuery = query(collection(db, "Users"), where("role", "==", "Admin"), where("orgId", "==", orgId));
      const adminSnapshot = await getDocs(adminQuery);

      if (adminSnapshot.size <= 1) {
        alert("Cannot delete the last remaining Admin user.");
        return;
      }
    }



    try {
      const docRef = doc(db, "Users", item.id);
      await deleteDoc(docRef);
      console.log('Document successfully deleted!');
    } catch (error) {
      console.error('Error deleting document: ', error);
    }
  };

  const handleCloseModal = () => {
    setCurrentItem(null);
  };

  const handleSignOut = () => {
    auth.signOut();
  };

  const DropdownMenu = () => {
    return (
      <div style={styles.menu}>
        <div style={styles.menuItem}>Plan: Free Tier</div>
        <div style={styles.menuItem}>Settings</div>
        <div style={styles.menuItem}>Resource Center</div>
        <div style={styles.menuItem} onClick={handleSignOut}>Sign Out</div>
      </div>
    );
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={styles.header}>
        <h2>Manage Users</h2>
        <div style={styles.container} onClick={() => setDropdownVisible(!isDropdownVisible)}>
          <div style={styles.accountText}>Account</div>
          {isDropdownVisible && <DropdownMenu />}
        </div>
      </div>
      <UserInput currentItem={currentItem} onCloseModal={handleCloseModal} />
      <hr style={{ margin: '20px 0' }} />
      <Table orgId={orgId} headers={userHeaders} collectionName="Users" onDelete={handleDelete} />
    </div>
  );
}

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px', // Added margin for spacing
  },
  container: {
    position: 'relative',
    cursor: 'pointer',
  },
  menu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    minWidth: '150px',
    zIndex: 1000,
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)' // Added shadow for better visibility
  },
  menuItem: {
    padding: '10px',
    borderBottom: '1px solid #ddd',
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: '14px',
    ':last-child': { // Ensure the last item has no border
      borderBottom: 'none'
    }
  },
  accountText: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
}

export default Users;


